'use client';

import { useEffect } from 'react';

type ResourceConfig = {
  url: string;
  rel?: 'prefetch' | 'preload';
  as?: 'script' | 'style' | 'image' | 'font' | 'fetch' | 'document';
};

export function useIdleLoad(resources: string[] | ResourceConfig[]) {
  useEffect(() => {
    resources.forEach((resource) => {
      const config: ResourceConfig =
        typeof resource === 'string'
          ? { url: resource, rel: 'prefetch', as: 'script' }
          : { rel: 'prefetch', as: 'script', ...resource };

      const { url, rel, as } = config;

      if (document.querySelector(`link[href="${url}"]`)) return;

      const link = document.createElement('link');
      link.rel = rel!;
      link.href = url;
      if (as) {
        link.as = as;
      }
      document.head.appendChild(link);
    });
  }, [JSON.stringify(resources)]);
}
